import React, { useState, useEffect, useRef, useCallback } from 'react';
import { MOBILE_OS } from '@src/constants/os';
import { getMobileOperatingSystem } from '@src/utils/osMobile';
import Card from '@src/components/Card';
import FullScreenCircularProgress from '@src/new-components/Progress/FullScreenCircularProgress';
import Header from './Header';
import Content from './Content';
import VoiceLibraryMobile from './VoiceLibraryMobile';
import { StyledVoiceLibraryContainer } from './index.style';

const VoiceLibrary = () => {
  const contentRef = useRef(null);
  const [os, setOs] = useState(null);

  useEffect(() => {
    const osDetected = getMobileOperatingSystem();
    setOs(osDetected);
  }, []);

  const handleScrollToTop = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ top: 0, behavior: 'smooth' });
    }
  }, []);

  if (!os) {
    return <FullScreenCircularProgress size={45} />;
  }

  if (os !== MOBILE_OS.UNKNOWN) {
    return <VoiceLibraryMobile />;
  }

  return (
    <StyledVoiceLibraryContainer ref={contentRef}>
      <Card flexDirection="column" className="voice-library-card">
        <div className="voice-library-wrapper">
          <Header />
          <Content handleScrollToTop={handleScrollToTop} />
        </div>
      </Card>
    </StyledVoiceLibraryContainer>
  );
};

export default VoiceLibrary;
